import { classNames } from '@dimjs/utils';
import { hooks } from '@wove/react';
import { FC, useRef } from 'react';
import { TouchableService } from './touchable-service';

export type NativeLockScrollProps = React.HTMLAttributes<HTMLDivElement>;

export const NativeLockScroll: FC<NativeLockScrollProps> = (props) => {
  const rootRef = useRef<HTMLDivElement>();
  const touchService = useRef(new TouchableService());

  const lock = hooks.useCallbackRef(() => {
    touchService.current.changeDisableTouchMove(true, rootRef.current);
    rootRef.current?.addEventListener('touchstart', touchService.current.handleTouchStart);
    rootRef.current?.addEventListener('touchmove', touchService.current.handleTouchMove);
  });

  const unlock = hooks.useCallbackRef(() => {
    touchService.current.changeDisableTouchMove(false, rootRef.current);
    rootRef.current?.removeEventListener('touchstart', touchService.current.handleTouchStart);
    rootRef.current?.removeEventListener('touchmove', touchService.current.handleTouchMove);
  });

  const rootRefHandle = hooks.useCallbackRef((node) => {
    if (node) {
      rootRef.current = node;
      lock();
    }
  });

  hooks.useUnmountEffect(() => {
    unlock();
  });

  return (
    <div {...props} ref={rootRefHandle} className={classNames('v-native-lock-scroll', props.className)}>
      {props.children}
    </div>
  );
};
